export const authTranslations = {
  // Login
  login: 'Sign In',
  password: 'Password',
  forgotPassword: 'Forgot Password?',
  dontHaveAccount: "Don't have an account?",
  signUp: 'Sign Up for Free',
  Korean: 'Korean',
  email: 'Email',
  emailPlaceholder: 'name@work-email.com',
  incorrectUsernameOrPassword:
    'Incorrect username or password. Please try again.',
  userDoesNotExist: 'User does not exist. Please sign up first.',
  loginFailed: 'Login failed. Please try again.',
  continueWithEmail: 'Continue with Work Email',
  enterYourPassword: 'Enter your password',
  enterYourPasswordDescription: 'Please enter your password to continue.',

  // Social Sign-In
  continueWithGoogle: 'Continue with Google',
  continueWithKakao: 'Continue with Kakao',
  continueWithMicrosoft: 'Continue with Microsoft',
  OR: 'OR',
  socialSignInError:
    'Something went wrong with social sign-in. Please try again.',

  // Sign Up
  createAccount: 'Create an account',
  createPassword: 'Create a password',
  createPasswordDescription: 'Please enter new password to sign up.',
  firstName: 'First Name',
  lastName: 'Last Name',
  passwordPlaceholder: 'New Password',
  passwordConfirm: 'Confirm Password',
  passwordConfirmPlaceholder: 'Confirm new password',
  passwordConfirmError: 'Passwords do not match',
  passwordConfirmErrorMessage: 'Passwords do not match',
  at8Characters: 'At Least 8 Characters',
  useOfUppercase: 'Use 3 of: uppercase, lowercase, number, symbol',
  alreadyHaveAccount: 'Already have an account?',
  personalInformation: 'Personal Information',
  company: 'Company',
  position: 'Position',
  continue: 'Continue',
  Email: 'Email',
  signupComplete: 'Signup Complete',
  signupCompleteSubtitle: 'Please log in with your new account.',
  whatsYourName: "What's your name?",
  enterYourNameDescription: 'Enter your name so we can address you properly.',
  name: 'Name',

  // Email Verification
  weEmailedYou: 'We emailed you',
  weEmailedYouDescription:
    'To create a new password, enter the code we emailed to {{email}}. It may take a minute to arrive.',
  codeOnTheWay:
    'Your code is on the way. To log in, enter the code we emailed to {{email}}. It may take a minute to arrive.',
  codeOnTheWay2: 'emailed to',
  codeDelay: 'It may take a minute to arrive.',
  enterYourCode: 'Enter your code',
  confirm: 'Confirm',
  resendCode: 'Resend the Code',
  code: 'Code',
  codeResent: 'Code resent please check your email.',
  codeLimitExceeded: 'Attempt limit exceeded, please try after some time.',
  loggingIn: 'Signing you in...',
  loggingInDescription: 'Almost there, redirecting to Cheiron...',
  codeValidationError: 'Invalid verification code. Please check and try again.',
  resendEmail: 'Resend Email',

  // Password Reset
  resetPassword: 'Reset Password',
  resetPasswordDescription: 'Enter your account email to reset your password.',
  enterYourEmail: 'Enter your email',
  passwordChanged: 'Password Changed',
  loginWithNewPassword: 'Please log in with your new password.',
  createNewPassword: 'Create a new password',
  setNewPassword: 'Set a new password for your account.',
  newPassword: 'New password',
  confirmNewPassword: 'Confirm new password',
  codeInvalid: 'The code you entered is invalid.',
  somethingWentWrong: 'Something went wrong. Please try again.',
  checkInbox: 'Check your inbox',
  checkInboxDescription:
    'Enter the verification code we just sent you to {{email}}',
  createNewPasswordDescription1: 'Please enter new password to continue.',
  createNewPasswordDescription2:
    'Your password must contain at least 8 characters, uppercase, lowercase, numbers, and special characters.',
  updatePassword: 'Update Password',
  // Password Requirements
  passwordLength8:
    'Password must be at least 8 characters including at least 3 of uppercase, lowercase, numbers, and special characters.',
  passwordNotMatch: 'Password does not match.',
  passwordChangedDescription:
    'Your password has been changed successfully. \n Please log in with your new password.',
  passwordUpdateFailed: 'Password update failed. Please try again.',

  // Account Deletion
  deleteAccount: 'Delete your account',
  deleteAccountDescription:
    'To confirm deletion, please enter your password linked to your account.',
  enterPassword: 'Enter your password',
  passwordRequired: 'Password is required',
  deletingAccount: 'Deleting Account',
  accountDeleted: 'Account successfully deleted',
  accountDeletionFailed: 'Failed to delete account. Please try again.',
  DeleteYourAccount: 'Delete your account?',
  YouNeedToLogInAgain:
    'You need to log in again to proceed with permanent account deletion.',
  LogInToDelete: 'Log In to Delete',
  DeletionComplete: 'Deletion Complete',
  YourAccountHasBeenDeleted: 'Your account has been successfully deleted.',

  //validations
  enterValidEmail: 'Please enter a valid email address.',
  enterValidPassword: 'Please enter a valid password.',
  enterValidFirstName: 'Please enter a valid name.',
  enterValidLastName: 'Please enter a valid last name.',
  enterValidName: 'Please enter a valid name.',
  thisEmailAlreadyRegistered: 'This email is already registered.',
  preSignUpFailedErrorMessage: 'Email is already in use by another account.',
  backtoLogin: 'Back to Login',

  //validations
  // Legal
  termsOfService: 'Terms of Service',
  privacyPolicy: 'Privacy Policy',
  adminPage: 'Admin Page',
  agreementText1:
    'By clicking “Sign up”, you agree to our Terms of Use and have read our Privacy Policy.',

  // Language
  english: 'English',
  korean: 'Korean',

  // Job Categories
  positionCategories: {
    researchRD: 'Research (R&D)',
    researchRDDetails:
      'Scientist, Researcher, Lab Staff, Discovery, Preclinical',

    salesMarketing: 'Sales & Marketing',
    salesMarketingDetails:
      'Sales, Marketing, Product Manager, Medical Sales Rep',

    manufacturingQuality: 'Manufacturing & Quality',
    manufacturingQualityDetails:
      'CMC, Quality Assurance (QA), Quality Control (QC), Engineering (ENG), Manufacturing Science & Technology (MSAT), Supply Chain Management (SCM)',

    clinicalDevelopment: 'Clinical Development',
    clinicalDevelopmentDetails:
      'Clinical Operations, Clinical Research, Medical Monitor, Study Coordinator, Clinical Data Management, Biostatistics',

    businessOperations: 'Business Operations',
    businessOperationsDetails:
      'Business Development, Finance, Legal, Human Resources (HR)',

    medicalAffairs: 'Medical Affairs',
    medicalAffairsDetails: 'MSL, Medical Information, Medical Communication',

    marketAccess: 'Market Access (MA)',
    marketAccessDetails: 'Health Economics, Reimbursement, Pricing',

    regulatoryAffairs: 'RA',
    regulatoryAffairsDetails: 'Regulatory Affairs',

    pharmacovigilance: 'Pharmacovigilance / Safety',
    pharmacovigilanceDetails: 'PV, Drug Safety, Risk Management',

    informationTechnology: 'Information Technology',
    informationTechnologyDetails: 'IT',

    physicianProfessor: 'Physician / Professor',
    physicianProfessorDetails: 'KOL, Investigator, Academic, HCP',

    others: 'Others',
    othersDetails: 'Please specify',
  },

  //Settings
  Settings: 'Settings',
  MyProfile: 'My Profile',
  Security: 'Security',
  Language: 'Language',
  Save: 'Save',
  Saving: 'Saving',
  Organization: 'Organization',
  Institution: 'Institution',
  Account: 'Account',
  Terms: 'Terms',
  TermsofUse: 'Terms of Use',
  PrivacyPolicy: 'Privacy Policy',
  PleaseEnterYourFirstName: 'Please enter your first name.',
  PleaseEnterYourLastName: 'Please enter your last name.',
  PleaseEnterYourEmail: 'Please enter your email.',
  PleaseEnterYourOrganization:
    'Please enter your organization/institution name.',
  ProfileUpdatedSuccessfully: 'Profile updated successfully',
  YourPasswordHasBeenUpdated: 'Your password has been updated.',
  loginSignup: 'Sign In ・ Sign Up',
  loginDescription: 'Sign in or create an account to continue.',
  ChangePassword: 'Change password',
  SignInWithYourPassword:
    "Sign in with your password if social login isn't available",
  DeleteAccount: 'Delete account',
  CannotDeleteAccount: 'Cannot delete account',
  GotIt: 'Got It',
  PermanentlyDeleteYourAccount: 'Permanently delete your account',
  AccountDeletionNotAllowedForExternalDomain:
    'Account deletion is only available to domain This account is linked to a managed domain.',
  ThisAccountIncludesAnExternalDomain:
    'This account is linked to a managed domain.',
  AccountDeletionIsOnlyAllowedForTheDomainAdministrator:
    'Please contact your domain administrator to remove your account from the domain first.',
  DeleteAccountConfirmTitle: 'Delete your account?',
  DeleteAccountConfirmDescription:
    'To confirm deletion, please enter the email linked to your account.',
  EnterYourEmailToConfirm: 'Enter your email to confirm',
  EmailDoesNotMatch: 'Email does not match.',
  Deleting: 'Deleting',
  AccountDeletedSuccessfully: 'Account deleted successfully.',
  ErrorDeletingAccount: 'An error occurred while deleting the account.',
  PermanentlyDeleteYourAccountAcrossAllDomains:
    'Permanently delete your account across all domains',

  // Change Password
  resetYourPassword: 'Reset your password',
  enterNewPasswordBelow: 'Enter a new password below to change your password.',
  currentPassword: 'Current password',
  resetPasswordButton: 'Change password',
  yourPasswordHasBeenChanged: 'Your password has been changed!',
  yourPasswordHasBeenResetDescription:
    'Your password has been changed. You can now continue to your account.',
  continueButton: 'Continue',
  incorrectCurrentPassword: 'Current password is incorrect.',
  LanguageUpdated: 'Language settings have been updated!',
  ManageYourAccountSecuritySettings: 'Manage your account security settings',
  KeepYourAccountSecure: 'Keep your account secure',
  DomainsLinkedToYourAccount: 'Domains linked to your account',
  PermanentlyDeleteYourAccountAndAllAssociatedData:
    'Permanently delete your account and all associated data',
  gobacktooltip: 'Go back to the previous page',
  // Tenant Selection
  SelectDomain: 'Select a domain',
  ChooseDomainDescription: 'Choose a domain you would like to use.',
  Managed: 'Managed',

  // logout
  Logout: 'Logout',
}
